import { FLAVORS, PACKS, SUB_PLAN, money } from 'v2/catalog.js';
import { planPricesMany } from 'v2/shopify.js';
import { $, $$, initChrome, addToCart } from 'v2/ui.js';

// Shop all: a plain product page for people who know what they want. The two variety packs first, then the flavors.
// Every card adds a case one time, or on the site's subscription (every 2 weeks, SUB_PLAN) at Shopify's price, fetched
// for every product that offers it in one Storefront API request (never the site's own discount arithmetic). A
// one-time-only product (catalog sub: false, Cranberry Cheer) has no Subscribe button.
// The cards themselves are baked into shop.html by tools/build-pages.py from js/catalog.js, so the page arrives
// drawn; rebuild after changing a product. This adds the live subscription prices and the subscribe clicks.

// Subscribe buttons wait for Shopify's plan prices; if Shopify can't be reached, they step aside and the product
// pages (and the cart's switch) still offer the subscription.
const subs = {};
const all = [...PACKS, ...FLAVORS].filter((p) => p.sub !== false);
planPricesMany(all.map((p) => p.variant)).then((prices) => {
  all.forEach((p) => {
    const s = prices[p.variant]?.[SUB_PLAN.id];
    const b = $(`[data-add-sub="${p.id}"]`);
    if (!s) { b.hidden = true; return; }
    subs[p.id] = s;
    $(`[data-sub-label="${p.id}"]`).innerHTML = `Subscribe<span class="sub-at"> · </span><span>${money(s.price)}</span>`;
    b.disabled = false;
  });
}).catch(() => { $$('[data-add-sub]').forEach((b) => { b.hidden = true; }); });

document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-add-sub]');
  const s = b && subs[b.dataset.addSub];
  if (s) addToCart(b.dataset.addSub, 1, { plan: SUB_PLAN.id, price: s.price, was: s.was, from: b });
});

initChrome();
